<template>
  <b-col cols="10" sm="4" offset="1" offset-sm="0"  data-aos="fade-up">
    <div class="news__wrapper"
      @click="changeNews"
      v-scroll-to="scrollToConfig"
      :class="{'news__wrapper--active' : activeNewsIndex === index} ">
      <div class="zoom-on-hover">
        <img class="news__img" :src="domain + `${news.photo}`" alt="">
      </div>
      <h5 class="news__title">{{news.title}}</h5>
      <template v-if="news.body">
        <p class="news__content" v-if="isOpen">
          {{ news.body }}
        </p>
        <p class="news__content" v-else
          v-html="$options.filters.shortContent(news.body, contentLimit)">
        </p>
      <b-btn v-if="!isOpen && news.body.length > contentLimit && isMobile" @click="isOpen = !isOpen"
        variant="primary" size="sm" class="news__button">
        Read more
      </b-btn>
      </template>
    </div>
  </b-col>
</template>

<script>
import filters from '@/utils/filters';
import { isMobile } from '@/utils/responsive';

export default {
  data() {
    return {
      isOpen: false,
      contentLimit: 90,
      isMobile,
      domain: process.env.SERVER_URL,
    };
  },
  computed: {
    scrollToConfig() {
      return (isMobile) ? {} : { el: '#scrollToOnLoad' };
    },
  },
  props: ['news', 'index', 'activeNewsIndex'],
  methods: {
    changeNews() {
      this.$emit('changeNews', this.index);
    },
  },
  filters: {
    shortContent: filters.shortContent,
  },
};

</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';
@import './src/styles/helpers/_include-media.scss';

.news {
  &__title {
    margin: 20px 0 5px;
  }
   &__img {
    height: 300px;
    width: 100%;
    background-size: cover;
    background-position: center;
    @include media('<lg') {
      height: 160px;
      margin-bottom: 10px;
    }
    @include media('<sm') {
      height: 200px;
      margin-bottom: 35px;
    }
  }
  &__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
    &--active {
      opacity: 0.5;
      @include media('<sm') {
        opacity: 1;
      }
    }
    @include media('<lg') {
      height: 260px;
    }
    @include media('<sm') {
      height: auto;
      margin-bottom: 40px;
    }
  }
  &__content {
    height: 75px;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 12px;
    margin: 0;
    @include media('<lg') {
      padding: 0 5px;
    }
    @include media('<sm') {
      padding-top: 10px;
      height: auto;
    }
  }
  &__button {
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/News/SingleNews.vue